class VideoPlayer extends HTMLElement {
  video = null;

  connectedCallback() {
    const video = this.querySelector('video');
    if (video) {
      this.video = video;
      this.initialize();
    }
  }

  initialize() {
    // Select elements in the dom that we need for the video player
    this.playPause = this.querySelector('[data-video="play-pause"]');
    this.muteButtons = this.querySelectorAll('[data-video-mute]');

    // Ensure autoplay videos are muted
    if (this.video.autoplay) {
      this.video.muted = true;
      this.classList.add('muted');
    }

    // Add event listeners to elements
    if (this.playPause) {
      this.playPause.addEventListener('click', () => {
        this.togglePlayPause();
      });
    }

    this.video.addEventListener('click', () => {
      this.togglePlayPause();
    });

    this.muteButtons?.forEach((muteButton) => {
      muteButton?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleMute();
      });
    });

    this.video.addEventListener('ended', () => {
      console.log('ended');
      if (!this.video.loop) {
        this.classList.remove('playing');
      }
    });
  }

  /**
   * togglePlayPause
   * @description Set the video to play or pause.
   */
  togglePlayPause() {
    if (this.video.paused) {
      this.playVideo();
    } else {
      this.pauseVideo();
    }
  }

  /**
   * toggleMute
   * @description Toggle between muted and unmuted state.
   */
  toggleMute() {
    if (this.video.muted) {
      this.unmuteVideo();
    } else {
      this.muteVideo();
    }
  }

  /**
   * unmuteVideo
   */
  unmuteVideo() {
    this.video.muted = false;
    this.video.removeAttribute('muted');
    this.classList.remove('muted');
  }

  /**
   * muteVideo
   */
  muteVideo() {
    this.video.muted = true;
    this.video.setAttribute('muted', '');
    this.classList.add('muted');
  }

  /**
   * pauseVideo
   */
  pauseVideo() {
    this.video.pause();
    this.classList.remove('playing');
  }

  /**
   * playVideo
   */
  playVideo() {
    this.video.play();
    this.classList.add('playing');
  }
}

customElements.define('video-player', VideoPlayer);
